<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <!-- header  -->
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-book"></i> Education Kit</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <button class="btn btn-primary btn-sm" [routerLink]="['/dashboard']"><i class="fa fa-arrow-left"></i> Back</button>
                </div>
            </div>
            <!--end header-->
        

             <div class="row row-replace m-t-30">
                 <div class="col-12 text-center">

                    <div class="container">
                        <div class="row">
                            <div class="col-4">
                                <a>
                                    <img src="assets/img/quick/edu_guide.png" width="100"> 
                                    <p>Education Kit</p>
                                </a>
                            </div>
                            <div class="col-4">
                               <a><img src="assets/img/quick/next_10th.jpg" width="100"></a>
                            </div>
                            <div class="col-4">
                               <a href="https://www.shaalaa.com/" target="_blank"><img src="assets/img/quick/shaala.png" width="100"></a>
                            </div>
                        </div>
                    </div>
                </div>
             </div>

             
             

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

